function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "File / Notebook"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M10.6668 5.33398H9.60042C8.10695 5.33398 7.35966 5.33398 6.78923 5.62463C6.28746 5.8803 5.87981 6.28795 5.62415 6.78971C5.3335 7.36014 5.3335 8.10744 5.3335 9.60091V22.4009C5.3335 23.8944 5.3335 24.6407 5.62415 25.2112C5.87981 25.7129 6.28746 26.1213 6.78923 26.377C7.3591 26.6673 8.10549 26.6673 9.59604 26.6673H10.6668M10.6668 5.33398H22.4004C23.8939 5.33398 24.6396 5.33398 25.21 5.62463C25.7118 5.8803 26.1208 6.28795 26.3765 6.78971C26.6668 7.35959 26.6668 8.10598 26.6668 9.59653V22.4054C26.6668 23.896 26.6668 24.6413 26.3765 25.2112C26.1208 25.7129 25.7118 26.1213 25.21 26.377C24.6401 26.6673 23.8948 26.6673 22.4043 26.6673H10.6668M10.6668 5.33398V26.6673M16.0002 14.6673H21.3335M16.0002 10.6673H21.3335",
  stroke: "white",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var SvgNotebook = function SvgNotebook(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNotebook, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/notebook.699bf924.svg";
export { ForwardRef as ReactComponent };